import React, { useEffect, useState } from 'react'

import { ToggleSwitchProps } from '../../../common/types'

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  checked,
  disabled,
  className,
  onChange,
  label,
}) => {
  const [isChecked, setIsChecked] = useState(checked ?? false)

  const handleToggle = () => {
    if (!disabled) {
      const newChecked = !isChecked
      setIsChecked(newChecked)
      onChange(newChecked)
    }
  }
  useEffect(() => {
    setIsChecked(checked ?? false)
  }, [checked])
  return (
    <div className={`switch ${className}`}>
      <input
        type="checkbox"
        id={id}
        checked={isChecked ?? undefined}
        onChange={handleToggle}
        disabled={disabled}
      />
      <label htmlFor={id} className="">
        {label}
      </label>
    </div>
  )
}

export default ToggleSwitch
